import React from 'react'
// libs
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import { formValueSelector } from 'redux-form'
// components
import { TrashIcon } from 'components/UI/Icons'
import { ReduxColorPanel, ReduxInput, ReduxSelect } from 'components/FormElements/ReduxForm'
// context
import { KPIContext } from 'context/index'
// constants
import { KPI_RESULT_TARGET_TYPE_OPTIONS, KPI_RESULT_TARGET_TYPE_VALUES, KPI_RESULT_TYPE_VALUES } from 'constants/index'
// themes
import { colors } from 'themes/index'
// utils
import get from 'lodash/get'
import { getValueFromOption, required } from 'utils/index'
import { generateScaleOptions } from 'utils/kpi'

// styled
const AddButton = styled.div`
  display: inline-block;

  font-size: 14px;
  color: ${colors.blue500};
  font-weight: 500;

  cursor: pointer;

  margin-top: 16px;
  margin-bottom: 16px;
  width: fit-content;
`

const RowContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  white-space: nowrap;
  margin-bottom: 16px;

  > :not(:last-child) {
    flex: 1;
    max-width: 240px;
  }
`

const ColorContainer = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 12px;
`

const ResultRow = ({ fields, targetForm }) => {
  const { entity } = React.useContext(KPIContext)

  const selector = formValueSelector(targetForm)

  const { resultInputType, resultTypeScale } = useSelector((state) => ({
    resultInputType: selector(state, 'resultInputType'),
    resultTypeScale: selector(state, 'resultTypeScale')
  }))

  // constants
  const resultType = get(resultInputType, 'label', '').toUpperCase()
  const isValue = resultType === KPI_RESULT_TYPE_VALUES.VALUE
  const isScale = resultType === KPI_RESULT_TYPE_VALUES.SCALE
  const scaleValue = resultTypeScale || get(entity, 'resultTypeScale', [])
  const scaleOptions = generateScaleOptions(scaleValue)

  return (
    <>
      {fields.map((field, idx) => {
        const currentItem = fields.get(idx)
        const type = getValueFromOption(currentItem.type)

        return (
          <RowContainer key={idx}>
            Result is:
            <ReduxSelect name={`${field}.type`} options={KPI_RESULT_TARGET_TYPE_OPTIONS} validate={required} />
            {type === KPI_RESULT_TARGET_TYPE_VALUES.GREATER && (
              <>
                {isValue && <ReduxInput name={`${field}.greaterValue`} validate={required} />}
                {isScale && <ReduxSelect name={`${field}.greaterValue`} options={scaleOptions} validate={required} />}
              </>
            )}
            {type === KPI_RESULT_TARGET_TYPE_VALUES.BETWEEN && (
              <>
                {isValue && <ReduxInput name={`${field}.betweenLower`} validate={required} />}
                {isScale && <ReduxSelect name={`${field}.betweenLower`} options={scaleOptions} validate={required} />}
                and
                {isValue && <ReduxInput name={`${field}.betweenUpper`} validate={required} />}
                {isScale && <ReduxSelect name={`${field}.betweenUpper`} options={scaleOptions} validate={required} />}
              </>
            )}
            {type === KPI_RESULT_TARGET_TYPE_VALUES.LESS && (
              <>
                {isValue && <ReduxInput name={`${field}.lessValue`} validate={required} />}
                {isScale && <ReduxSelect name={`${field}.lessValue`} options={scaleOptions} validate={required} />}
              </>
            )}
            <ColorContainer>
              <ReduxColorPanel name={`${field}.color`} decorated>
                {(color) => color}
              </ReduxColorPanel>
              <TrashIcon onClick={() => fields.remove(idx)} />
            </ColorContainer>
          </RowContainer>
        )
      })}
      <AddButton onClick={() => fields.push({ color: colors.green500 })}>+ Add result target range</AddButton>
    </>
  )
}

export default ResultRow
